export default String.raw`
(function () {
    if (!body) {
        var body = $('body');
    }

    // !NOTE!: function arguments like 'elementSelector' could also be DOM elements or jQuery objects
    // UI FEATURES implementation
    function UIFeatures() {
        //attach element to the top of window when page scrolls under the element. Can set given class when element is attached.
        this.attachElement = function (element, classWhenAttached, bottomStop, callback) {
            var element = $(element);

            if (element.length > 0) {
                var offsetTop = element.offset().top;
                var offsetLeft = element.offset().left;
                var offsetRight = $(window).width() - offsetLeft - element.width() + 'px';

                if (offsetLeft < 0 || offsetRight < 0) {
                    var offsetLeft = null;
                    var offsetRight = null;
                }

                if (!bottomStop) {
                    bottomStop = Infinity;
                }

                var bodyMarginTop = parseFloat(window.getComputedStyle($('body').get(0)).marginTop);

                if (bodyMarginTop < 0) {
                    bodyMarginTop = 0;
                }

                element.addClass('element-not-attached-js');
                element.removeClass('element-attached-js');

                var positionType = element.css('position');
                var positionTop = element.css('top');

                var attachEventCallback = function (e) {
                    if (element.css('display') != 'none' && Math.round($(element).height()) <= $(window).height()) {
                        if (!offsetLeft || !offsetRight) {
                            offsetLeft = element.offset().left;
                            offsetRight = $(window).width() - offsetLeft - element.width() + 'px';
                        }
                        if (offsetLeft < 0 || offsetRight < 0) {
                            offsetLeft = null;
                            offsetRight = null;
                        } else {
                            var scrollPositon = $(window).scrollTop() + bodyMarginTop;
                            
                            if (scrollPositon > offsetTop && scrollPositon < bottomStop) {

                                element.addClass('element-attached-js');
                                element.removeClass('element-not-attached-js');

                                if (classWhenAttached) {
                                    element.addClass(classWhenAttached);
                                }
                            } else {
                                element.css({
                                    position: positionType,
                                    top: positionTop,
                                    left: 0,
                                    right: 0
                                });

                                element.addClass('element-not-attached-js');
                                element.removeClass('element-attached-js');

                                if (classWhenAttached) {
                                    element.removeClass(classWhenAttached);
                                }
                            }
                        }
                    }
                };

                attachEventCallback();
                $(window).on('scroll', attachEventCallback);

                if (callback) {
                    callback();
                }
            }
        };

        //event propagation fixes
        this.propagationFixes = (function f() {

            //disable page reload after click on form element inside anchor
            $('a input, a button, a textarea').on('click', function (e) {
                if (e) {
                    e.preventDefault();
                } else {
                    return false;
                }
            });

            return f;
        })();

        //toogle content of given container by click on given button
        this.toggleContent = function (button, contentSelector) {
            var button = $(button);
            var contentSelector = contentSelector || button.data('content') || '.toggleContent';
            var container = button.parent().find(contentSelector);
            container.toggleClass('hidden-js');
            if (button.data('toggle-label')) {
                var currentLabel = button.text();
                var nextLabel = button.data('toggle-label');
                button.text(nextLabel);
                button.data('toggle-label', currentLabel);
            }
        };

        //expand/collapse aditional data by changing height
        this.expandHeight = function (expandTriggerSelector, expandedContentSelector, expandedClass, minHeight) {
            var expandTrigger = $(expandTriggerSelector);
            var expandedContentElements = $(expandedContentSelector);
            expandedContentElements.css('overflow-y', 'hidden');
            if (!minHeight) {
                var minHeight = 0;
            }
            $(expandedContentElements).each(function () {
                var expandedContent = $(this);

                if (!minHeight && expandedContent.data('min-height')) {
                    minHeight = expandedContent.data('min-height');
                }

                //get height of expanded content (because css can't animate from/to auto)
                var expandedContentHeight = 0;

                if (expandedContent.data('height')) {
                    expandedContentHeight = expandedContent.data('height');
                } else {
                    if (expandedContent.height() == minHeight) {
                        /* current styles of expanded content */
                        var expandedContentLeft = expandedContent.css('left');
                        var expandedContentPositionType = expandedContent.css('position');
                        var expandedContentDisplay = expandedContent.css('display');
                        var expandedContentVisibility = expandedContent.css('visibility');
                        var expandedContentWidth = expandedContent.css('width');
                        var expandedParentPositionType = expandedContent.parent().css('position');

                        expandedContent.parent().css('position', 'relative');

                        /* get content height */
                        expandedContent.css({
                            left: '-10000%',
                            position: 'absolute',
                            display: 'block',
                            visibility: 'visible',
                            width: '100%',
                            height: 'auto'
                        });

                        expandedContentHeight = expandedContent.css('height');

                        /* reset styles of expanded content */
                        expandedContent.parent().css('position', expandedParentPositionType);

                        expandedContent.css({
                            left: expandedContentLeft,
                            position: expandedContentPositionType,
                            display: expandedContentDisplay,
                            visibility: expandedContentVisibility,
                            width: expandedContentWidth,
                            height: 0
                        });
                    } else {
                        expandedContentHeight = expandedContent.height();
                        expandedContent.css('height', expandedContentHeight + 'px');
                    }
                    
                    expandedContent.data('height', expandedContentHeight);
                }

                if (expandedContent.find('.characters-counter-js').index() != -1) {
                    var expandedContentHeightValue = Number(expandedContentHeight.slice(0, -2));
                    expandedContentHeightValue += 10;
                    expandedContentHeight = expandedContentHeightValue + 'px';
                }

                // toggling
                if (expandedContent.height() == minHeight) {
                    expandedContent.css('height', expandedContentHeight);
                    expandTrigger.addClass(expandedClass);
                    expandedContent.addClass(expandedClass);
                } else {
                    expandedContent.css('height', minHeight);
                    expandTrigger.removeClass(expandedClass);
                    expandedContent.removeClass(expandedClass);
                }

                const timeOut = setTimeout(function () {
                    if (!expandTrigger.hasClass('affected-all-js')) {
                        expandTrigger.focus();
                    } else {
                        expandTrigger.removeClass('affected-all-js');
                    }
                    clearTimeout(timeOut);
                }, 1500);
            });
        }

$(window).on('resize', function() {
            if (window.resizeAnimFrame) {
                cancelAnimationFrame(window.resizeAnimFrame);
            }
            
            window.resizeAnimFrame = requestAnimationFrame(function() {
                $('.expandable-js.expanded-js').each(function() {
                    var expandedContent = $(this);
                    var expandedContentLeft = expandedContent.css('left');
                    var expandedContentPositionType = expandedContent.css('position');
                    var expandedContentDisplay = expandedContent.css('display');
                    var expandedContentVisibility = expandedContent.css('visibility');
                    var expandedParentPositionType = expandedContent.parent().css('position');
                    
                    var parentNewWidth = expandedContent.parent().width();
                    
                    expandedContent.parent().css('position', 'relative');
                    
                    expandedContent.css({
                        left: '-10000%',
                        position: 'absolute',
                        display: 'block',
                        visibility: 'visible',
                        width: window.innerWidth <= 768 ? '100%' : parentNewWidth + 'px',
                        height: 'auto'
                    });
                    
                    var expandedContentHeight = expandedContent.outerHeight() + 'px';
                    
                    expandedContent.parent().css('position', expandedParentPositionType);
                    expandedContent.css({
                        left: expandedContentLeft,
                        position: expandedContentPositionType,
                        display: expandedContentDisplay,
                        visibility: expandedContentVisibility,
                        width: window.innerWidth <= 768 ? '100%' : parentNewWidth + 'px',
                        height: expandedContentHeight
                    });
                    
                    expandedContent.data('height', expandedContentHeight);
                    expandedContent.data('width', parentNewWidth);
                });
            });
        });

        //returns GET variable by given name
        this.getGetVariable = function (variableName) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return null;
        }

        //makes post request and returns promise, can also call given function (optional) or emit given event (optional) after response
        this.makePostRequest = function (data, url, callback, callEvent, eventParams) {
            if (!url) {
                url = '';
            }

            if (!callback) {
                if (callEvent) {
                    return $.post(url, data, function (res) {
                        var params = eventParams || {};
                        params.response = res;
                        body.trigger(callEvent, params);
                    });
                } else {
                    return $.post(url, data);
                }
            }

            return $.post(url, data, function (res) {
                callback(res);
                if (callEvent) {
                    var params = eventParams || {};
                    params.response = res;
                    body.trigger(callEvent, params);
                }
            });

        }

        //makes get request and returns promise, can also call given function (optional) or call given event (optional) after response
        this.makeGetRequest = function (data, url, callback, callEvent, eventParams) {
            if (!url) {
                url = '';
            }

            if (!callback) {
                if (callEvent) {
                    return $.get(url, data, function () {
                        var params = eventParams || {};
                        params.response = res;
                        body.trigger(callEvent, params);
                    });
                } else {
                    return $.get(url, data);
                }
            }

            return $.get(url, data, function (res) {
                callback(res);
                if (callEvent) {
                    var params = eventParams || {};
                    params.response = res;
                    body.trigger(callEvent, params);
                }
            });
        }

        // pure replacing template, without unnessesary calls like google maps api, collection points, loading erp data etc.
        // calls given callback if exists
        // emits given event with given params, or (by default) emits replaceTemplate event with param object: {container: container's selector, templateUrl: template's url (or null if request wasn't needed)}
        // returns request's promise if server request is required, or null if doesn't
        this.pureReplaceTemplate = function (containerSelector, templateUrl, templateInclude, templateHTML, requestUrl, callback, callEvent, eventParams) {
            if (!callEvent) {
                callEvent = 'replaceTemplate';
                eventParams = {
                    container: containerSelector,
                    templateUrl: templateUrl || null
                };
            }

            if (templateHTML) {
                $(containerSelector).html(templateHTML);
                if (callback) {
                    callback(containerSelector);
                }
                body.trigger(callEvent, eventParams);
                return null;
            } else {
                if (!requestUrl) {
                    requestUrl = '';
                }

                var data = {
                    __template: templateUrl
                }

                if (templateInclude) {
                    data.__include = "'" + templateInclude + "'";
                }

                return this.makeGetRequest(data, requestUrl, function (res) {
                    $(containerSelector).html(res.template);
                    if (callback) {
                        callback(containerSelector, templateUrl);
                    }
                }, callEvent, eventParams);
            }
        }

        this.closePopup = function (closeTriggerSelector, popupSelector, hiddingClass) {
            var thisRef = this;
            body.on('click', closeTriggerSelector, function (e) {
                e.preventDefault();

                if (hiddingClass) {
                    $(this).parents(popupSelector).addClass(hiddingClass);
                } else {
                    $(this).parents(popupSelector).remove();
                }
            });
        }

        this.changeArrowTitle = function (e) {
            var $button = $(e.currentTarget);
            var title = $button.attr('title');
        
            $button.prop('disabled', true);
            
            var buttonTextNode = $button.contents().filter(function () {
                return this.nodeType === 3;
            }).first();
        
            if (title === __translations.showDetails) {
                $button.attr('title', __translations.hideDetails);
                if (buttonTextNode.length && buttonTextNode.text().trim() === __translations.showDetails) {
                    buttonTextNode.replaceWith(__translations.hideDetails);
                }
            } else {
                $button.attr('title', __translations.showDetails);
                if (buttonTextNode.length && buttonTextNode.text().trim() === __translations.hideDetails) {
                    buttonTextNode.replaceWith(__translations.showDetails);
                }
            }

            setTimeout(function () {
                $button.prop('disabled', false);
            }, 500);
        };
    }

    // UI FEATURES binding
    window.UIFeatures = new UIFeatures();

    //content attached to the top when scrolls down
    $('.attached-js').each(function () {
        var element = $(this);
        window.UIFeatures.attachElement(element, element.data('attached-class') || null);
    });

    $(document).ajaxSuccess(function (e, response) {
        if (response.responseJSON && response.responseJSON.template) {
            if(response.responseJSON.template.indexOf('attached-js') >= 0) {
                response.then(function () {
                    $(response.responseJSON.template).each(function () {
                        if ((this.className + '').indexOf('attached-js') > 0) {
                            var newElement = $(this);
                            newElement.css({
                                position: 'absolute',
                                left: 0,
                                right: 0
                            });
                            window.UIFeatures.attachElement(newElement, newElement.data('attached-class') || null);
                        }
                    });
                });
            }
        }
    });

    //expand/collapse content by changing height
    body.on('click', '.expand-data-js:not(.cant-toggle-js)', function (e) {
        e.stopPropagation();
        e.preventDefault();
        
        const trigger = $(this);
        let expandableContent;

        if (trigger.closest('tr').hasClass('with-attributes expandable-mechanism-container-js')) {
            expandableContent = trigger.closest('tr')
                .next('tr.attr-container-row')
                .find('.expandable-js');
        } else {
            const container = trigger.closest('.expandable-mechanism-container-js');
            
            if (trigger.next('.expandable-js').length) {
                expandableContent = trigger.next('.expandable-js');
            }
            else if (trigger.parent().next('.expandable-js').length) {
                expandableContent = trigger.parent().next('.expandable-js');
            }
            else {
                const triggerIndex = trigger.index('.expand-data-js:not(.cant-toggle-js)');
                expandableContent = container.find('.expandable-js').eq(triggerIndex);
                
                if (!expandableContent.length) {
                    const allExpandables = container.find('.expandable-js');
                    let closestExpandable = null;
                    let minDistance = Infinity;
                    
                    allExpandables.each(function() {
                        const distance = Math.abs($(this).offset().top - trigger.offset().top);
                        if (distance < minDistance) {
                            minDistance = distance;
                            closestExpandable = $(this);
                        }
                    });
                    
                    if (closestExpandable) {
                        expandableContent = closestExpandable;
                    }
                }
            }
        }
        
        if (expandableContent?.length) {
            window.UIFeatures.expandHeight(this, expandableContent, 'expanded-js');
        }
        
        setTimeout(function(){
            if($('.products-table-js').length && !$('.products-table-header-js.element-attached-js').length){
                const productsTable = $('.products-table-js');
                window.UIFeatures.attachElement('.products-table-header-js', null, 
                    productsTable.offset().top + productsTable.height());
            }
        }, 1000);
    });

    body.on('click', '.change-arrow-title-js:not(.cant-toggle-js)', function(e) {
        e.stopPropagation();
        e.preventDefault();
        window.UIFeatures.changeArrowTitle(e)
    });

    //closing closable popups
    window.UIFeatures.closePopup('.close-js', '.closable-popup-js', 'hidden-js');
})();

$('body').on('click', '.print-js', function(e) {
    window.print();
});

$('body').on('click', '[name="quantity"]', function(e) {
    e.stopPropagation();
});

/**
 * Parses a string to a number, replacing the custom decimal separator if needed.
 * @param {string|number} value - The value to parse.
 * @param {string} decSep - The decimal separator to replace.
 * @returns {number}
 */
function parseNumberWithDecSep(value, decSep = __decSep) {
    if (typeof value === 'string' && value.indexOf(decSep) !== -1) {
        value = value.replace(decSep, '.');
    }
    return Number(value);
}

/**
 * Collects data attributes and state from all elements with the class "child-js" inside a given container
 * and stores a normalized array of child descriptor objects on the global window.childs.
 *
 * @function saveChildsProps
 * @param {Document|Element|ParentNode} [container=document] Root container within which to query ".child-js" elements.
 * @global
 * @returns {void} No return value; results stored in window.childs.
 */
function saveChildsProps(container = document) {
    // Returns all childs to window.childs
    window.childs = [];

    // Legacy: container adjustment
    if($('.add-variants-to-cart-from-prod-list-popup-background-js').length > 0 && $('.product-presentation-js').length > 0){
        container = document.querySelector('.add-variants-to-cart-from-prod-list-popup-background-js');
    }

    const childs = container.querySelectorAll('.child-js');
    const graphicalVariants = container.querySelector('.graphical-variant-js') ? true : false;

    childs.forEach((childEl, index) => {
        // Build child object properties
        let child = {
            no: index,
            el: childEl,
            graphicalEl: graphicalVariants ? $(container).find('.product-container-js') : null,
            attributesEl: graphicalVariants ? $(container).find('.attributes-container-js') : $(childEl).next(),
            currency: __curr,
            isActive: $(childEl).hasClass('active-js'),
            askForPriceChild: $(childEl).hasClass('ask-for-price-child-js'),
            noSupplyProductOnControlledStock: $(childEl).find('.no-supply-product-on-controlled-stock-js').length > 0,
            moreAttrOpened: graphicalVariants ? true : $(childEl).find('.expanded-js').length > 0,
            supply: $(childEl).find('input[name="supplyId"]').val(),
            unit: $(childEl).find('[data-unit]').data('unit') || '',
            hasAttributes: $(childEl).hasClass('with-attributes'),
            code: $(childEl).data('code'),
            img: $(childEl).data('img'),
            cantToggle: false
        };

        // Quantity
        const quantity = graphicalVariants ? $(child.graphicalEl).find('[name="quantity"]').val() : $(childEl).find('[data-quantity]').data('quantity');
        let parsed = parseNumberWithDecSep(quantity);
        child.quantity = isNaN(parsed) ? 0 : parsed;
        child.quantityString = child.quantity.toString();

        // Legacy: EAN handling
        if(childEl.querySelectorAll('[data-ean]').length > 0){
            var mainEan = $('.main-ean-js').text();
            var ean = childEl.querySelector('[data-ean]').dataset.ean;
            var eanArr = ean.split(',');
            var eansString = mainEan + ',<br>';
            for(var j=0; j<eanArr.length; j++){
                var eanCode = eanArr[j].split('|')[0];
                var id = eanArr[j].split('|')[1];
                if(id == 'null'){
                    id = '';
                } else {
                    id = Number(id);
                }
                if(unit == id){
                   eansString += eanCode + ',<br>';
                }
            }
            child.ean = eansString.slice(0, -5);
        }
        
        // Get brutto price
        child.brutto = graphicalVariants? $(child.graphicalEl).find('[data-brutto-price]').data('bruttoPrice') : $(childEl).find('[data-brutto-price]').data('bruttoPrice');
        parsed = parseNumberWithDecSep(child.brutto);
        child.brutto = isNaN(parsed) ? undefined : parsed;

        // Get netto price
        child.netto = graphicalVariants ? $(child.graphicalEl).find('[data-netto-price]').data('nettoPrice') : $(childEl).find('[data-netto-price]').data('nettoPrice');
        parsed = parseNumberWithDecSep(child.netto);
        child.netto = isNaN(parsed) ? undefined : parsed;

        // Get deposit price
        child.deposit = graphicalVariants ? $(child.graphicalEl).find('[data-deposit-price]').data('depositPrice') : $(childEl).find('[data-deposit-price]').data('depositPrice');
        parsed = parseNumberWithDecSep(child.deposit);
        child.deposit = isNaN(parsed) ? undefined : parsed;

        // Get brutto previous price
        child.bruttoPrevious = graphicalVariants ? $(child.graphicalEl).find('[data-bruttoprevious-price]').data('bruttopreviousPrice') : $(childEl).find('[data-bruttoprevious-price]').data('bruttopreviousPrice');
        parsed = parseNumberWithDecSep(child.bruttoPrevious);
        child.bruttoPrevious = isNaN(parsed) ? undefined : parsed;

        // Get netto previous price
        child.nettoPrevious = graphicalVariants ? $(child.graphicalEl).find('[data-nettoprevious-price]').data('nettopreviousPrice') : $(childEl).find('[data-nettoprevious-price]').data('nettopreviousPrice');
        parsed = parseNumberWithDecSep(child.nettoPrevious);
        child.nettoPrevious = isNaN(parsed) ? undefined : parsed;

        // Get brutto lowest price
        child.bruttoLowest = graphicalVariants ? $(child.graphicalEl).find('[data-bruttolowest-price]').data('bruttolowestPrice') : $(childEl).find('[data-bruttolowest-price]').data('bruttolowestPrice');
        parsed = parseNumberWithDecSep(child.bruttoLowest);
        child.bruttoLowest = isNaN(parsed) ? undefined : parsed;

        // Get netto lowest price
        child.nettoLowest = graphicalVariants ? $(child.graphicalEl).find('[data-nettolowest-price]').data('nettolowestPrice') : $(childEl).find('[data-nettolowest-price]').data('nettolowestPrice');
        parsed = parseNumberWithDecSep(child.nettoLowest);
        child.nettoLowest = isNaN(parsed) ? undefined : parsed;

        // Get stock value
        child.stock = graphicalVariants ? $(child.graphicalEl).find('[data-stock-value]').data('stockValue') : $(childEl).find('[data-stock-value]').data('stockValue');
        parsed = parseNumberWithDecSep(child.stock);
        child.stock = isNaN(parsed) ? undefined : parsed;

        // If quantity is equal to stock, set buyAll to true
        child.buyAll = false;
        if(child.quantity == child.stock){
            child.buyAll = true;
        }

        // Get stock not max value
        child.stockNotMax = graphicalVariants
            ? $(child.graphicalEl).find('[data-stock-not-max-value]').data('stockNotMaxValue')
            : $(childEl).find('[data-stock-not-max-value]').data('stockNotMaxValue');
        parsed = parseNumberWithDecSep(child.stockNotMax);
        child.stockNotMax = isNaN(parsed) ? undefined : parsed;

        // Unit ratio info flag
        child.unitRatioInfo = graphicalVariants
            ? $(child.graphicalEl).find('[data-unit-ratio-info]').data('unitRatioInfo')
            : $(childEl).find('[data-unit-ratio-info]').data('unitRatioInfo');

        // Get basic unit
        child.basicUnit = graphicalVariants
            ? $(child.graphicalEl).find('[data-basic-unit]').data('basicUnit')
            : $(childEl).find('[data-basic-unit]').data('basicUnit');
        parsed = parseNumberWithDecSep(child.basicUnit);
        child.basicUnit = isNaN(parsed) ? undefined : parsed;

        // Get weight
        child.weight = $(childEl).data('weight');
        parsed = parseNumberWithDecSep(child.weight);
        child.weight = isNaN(parsed) ? undefined : parsed;

        // Get netweight
        child.netweight = $(childEl).data('netweight');
        parsed = parseNumberWithDecSep(child.netweight);
        child.netweight = isNaN(parsed) ? undefined : parsed;

        // Get keys based on whether the element has the child-reload-js class
        const hasChildReloadClass = $(childEl).hasClass('child-reload-js');
        // Get the keys
        child.keys = hasChildReloadClass
            ? $(childEl).find('[data-key]').map((_, el) => Number($(el).data('key'))).get()
            : $(container).find('.add-to-cart-js [name=attributeId]').map((_, el) => Number(el.value)).get(); // Polyvalent attributes case

        // Get attributes polyvalent and editable
        child.attributesPolyvalent = [];
        child.attributesEditable = [];

        if (!hasChildReloadClass && graphicalVariants && $('.attr-graphical-variants-js').length > 0) {
            activeAttributesIds = $(child.graphicalEl).find('.active-js input[name="attributeId"]').map(function() {
                return $(this).val();
            }).get();

            child.attributesPolyvalent = activeAttributesIds;
        }

        if (child.hasAttributes) {
            // Get attributes container
            const attributesEl = $(child.attributesEl);
            // Attributes polyvalent
            attributesEl.find('[name=attributePolyvalent]').each((_, el) => {
                const value = $(el).val();
                child.attributesPolyvalent.push(value);
                if ((value === '' || value.replace(/\s/g, '').length === 0) && child.quantity > 0) {
                    child.cantToggle = true;
                }
            });

            // Attributes editable
            attributesEl.find('[name=attributeEditable]').each((_, el) => {
                const value = $(el).val();
                child.attributesEditable.push(value);
                if ((value === '' || value.replace(/\s/g, '').length === 0) && child.quantity > 0) {
                    child.cantToggle = true;
                }
            });
        }

        window.childs.push(child);
    });

    // If graphical variants we should remove not active childs from window.childs
    if (graphicalVariants) {
        window.childs = window.childs.filter(child => child.isActive);
    }
}

/**
 * Initializes and synchronizes all UI elements and internal state related to the product's child variants.
 *
 * @param {number} [index] - The index of the child to load properties for.
*/
/**
 * Initializes and synchronizes all UI elements and internal state related to the product's child variants.
 *
 * @param {number} [index] - The index of the child to load properties for.
*/
function loadChildsProps(index) {
    let activeChildIndex = $('.child-js.active-js').data('child-index');

    if (activeChildIndex == undefined ) {
        activeChildIndex = index;
    }

    const activeChild = window.childs[activeChildIndex] || window.childs.find(child => child.isActive);

    // Set child dimensions
    const dimensionsEl = $('[data-child-index=' + activeChildIndex + '] .dimensions-js');
    if (activeChild && activeChild.unit !== undefined && dimensionsEl.length > 0) {
        const selectedUnitDimensions = dimensionsEl.attr('data-unit' + activeChild.unit);
        changeDimensions(selectedUnitDimensions);
    }

    // Set child weights
    if($('.product-attributes-js').length > 0) {
        changeWeights(activeChildIndex);
    }

    if($('.add-variants-to-cart-from-prod-list-popup-background-js').length > 0 && $('.product-presentation-js').length > 0){
        var childs = $('.add-variants-to-cart-from-prod-list-popup-background-js .child-js');
    } else {
        var childs = $('.child-js');
    }

    // Get/Set child quantities
    childs.each(function () {
        const childEl = $(this);
        const index = childEl.data('child-index');
        const child = window.childs[index];

        const graphicalVariants = child.graphicalEl ? true : false;
        const sourceEl = graphicalVariants ? $(child.graphicalEl) : childEl;
        if(!child.askForPriceChild) {
            sourceEl.find('[name=quantity]').val(child.quantityString);
            if(child.maxString != undefined){
                changeMaxQuantity(sourceEl, index);
            }
        }

        // Set child price
        if(child.ratio != undefined){
            changePrices(sourceEl, index);
        }

        // Set child unit
        const unitEl = sourceEl.find('.units-in-table-js');
        if(unitEl.length > 0 && child.unit !== undefined) {
            const options = unitEl.find('li');

            options.each(function () {
                const optionId = $(this).data('value');
                if(optionId == child.unit){
                    $(this).parents('.select-js').find('.selected-js').text($(this).text());
                    $(this).parents('.select-js').find('.memory-js').val(optionId);
                }
            });

            sourceEl.find('.unit-ratio-info-js').addClass('hidden-js');
            if(child.unitRatioInfo && child.unit){
                sourceEl.find('.unit-ratio-info-js[data-id='+child.unit+']').removeClass('hidden-js');
            }
        }

        if (child.hasAttributes) {
            const attributesEl = $(child.attributesEl);
            // Attributes editable
            if (child.attributesEditable.length > 0) {
                const attributesEditable = attributesEl.find('[name=attributeEditable]');

                attributesEditable.each(function(i) {
                    const value = child.attributesEditable[i];
                    $(this).val(value);

                    if (typeof $(this)[0] === 'select') {
                        if (value === '') {
                            $(this).find('option[value=""]').prop('selected', true);
                        } else {
                            $(this).find('option[value=' + value + ']').prop('selected', true);
                        }
                    }

                    const isEmpty = value === '' || value.replace(/\s/g, '').length === 0;
                    const hasValidationError = isEmpty && (!child.graphicalEl && child.quantity > 0);

                    if (hasValidationError) {
                        $(this).addClass('validation-error-js');
                        $(this).addClass('validation-error');
                        $(this).parents('.attribute-container-js').find('.validation-info-js').removeClass('hidden-js');
                        $(this).parents('.attribute-container-js').find('.select-arrow-ui').removeClass('no-error');
                    } else {
                        $(this).removeClass('validation-error-js');
                        $(this).removeClass('validation-error');
                        $(this).parents('.attribute-container-js').find('.validation-info-js').addClass('hidden-js');
                        $(this).parents('.attribute-container-js').find('.select-arrow-ui').addClass('no-error');
                    }
                });
            }

            // Attributes polyvalent
            if (child.attributesPolyvalent.length > 0) {
                const attributesPolyvalent = attributesEl.find('[name=attributePolyvalent]');

                attributesPolyvalent.each(function(i) {
                    const value = child.attributesPolyvalent[i];
                    $(this).val(value);
                    
                    if (typeof $(this)[0] === 'select') {
                        if (value === '') {
                            $(this).find('option[value=""]').prop('selected', true);
                        } else {
                            $(this).find('option[value=' + value + ']').prop('selected', true);
                        }
                    }

                    if ((value === '' || value.replace(/\s/g, '').length === 0) && child.quantity > 0) {
                        $(this).addClass('validation-error-js');
                        $(this).addClass('validation-error');
                        $(this).parents('.attribute-container-js').find('.validation-info-js').removeClass('hidden-js');
                        $(this).parents('.attribute-container-js').find('.select-arrow-ui').removeClass('no-error');
                    } else {
                        $(this).removeClass('validation-error-js');
                        $(this).removeClass('validation-error');
                        $(this).parents('.attribute-container-js').find('.validation-info-js').addClass('hidden-js');
                        $(this).parents('.attribute-container-js').find('.select-arrow-ui').addClass('no-error');
                    }
                });
            }
        }

        // Exapdable content
        const arrow = childEl.find('.expand-data-js');
        const expandableContent = childEl.find('.expandable-js');
        if((child.moreAttrOpened || child.quantity > 0) && $(this).find('div.expanded-js').index() == -1 && child.cantToggle && (window.innerWidth > 1279 || $(this).hasClass('active-js'))){
            arrow.addClass('no-animation-js');
            expandableContent.addClass('no-animation-js');
            arrow.click();
            setTimeout(function(){
                arrow.removeClass('no-animation-js');
                expandableContent.removeClass('no-animation-js');
            }, 800);
        }
        arrow.toggleClass('cant-toggle-js', child.cantToggle);

        app.blockQuantityButtons(undefined, sourceEl.find('[name=quantity]'));

        if (child.graphicalEl) {
            return false; // Stop iterating if graphicalEl is present
        }
    });

    // Legacy
    if (document.getElementsByClassName('review-content-js').length > 0) {
        const elements = document.getElementsByClassName('review-content-js');
        for(let element of elements){
            if (element.offsetHeight == element.scrollHeight) {
                const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
                for(let button of buttons){
                    button.classList.add('hidden-js');
                }
            }
        }
    }

    // Check if product is in cart and enable/disable button
    if (__productIsInCart == 'productIsInCart-yes' && $('.products-list-js').index() < 0) {
        let productId = parseInt($('#isInCartId').eq(0).val());
        app.getProductsIdsFromCart(function(res) {
            productsInCart = res;
            let isInCart = app.checkIfProductIsInCart(productsInCart, productId);
            app.enableDisableInCartButton(isInCart);
        });  
    }

    app.getProperBackground(); // Legacy, should be css
    $('.during-ajax-modal-js').addClass('hidden-js');
}
/**
 * Handles quantity input changes for a child product line, applying validation,
 * formatting, stock/max constraints, and attribute completeness checks.
 *
 * @param {Event} e - The event triggered by the quantity input change.
 */
function changeSavedQuantity(e){
    const toQuantity = (value) => {
        if(__decUnits == 'true'){
            if(__decSep != '.'){
                value = value.replace(__decSep, '.');
            }
            value = Number(value);
        }
        return value;
    }

    const toQuantityString = (value) => {
        if (typeof value !== 'string') {
            value = value.toString();
        }
        if(__decUnits == 'true'){
            value = value.replace('.', __decSep);
            var decimals = value.split(__decSep)[1];
            if(decimals != undefined && decimals.length == 1){
                value = value + '0';
            } else if(decimals == undefined){
                value = value + __decSep + '00';
            }
        }
        return value;
    }

    const graphicalVariants = $('.graphical-variant-js').length > 0;

    let input = graphicalVariants ? $(window.childs[0].graphicalEl).find('input[name="quantity"]') : $(e.currentTarget).closest('.quantity').find('input[name="quantity"]');

    const value = toQuantity(input.val());
    const childEl = $(e.currentTarget).closest('.child-js');
    const index = graphicalVariants ? 0 : childEl.data('child-index');
    const child = window.childs[index];


    if (value < 0 || index === undefined || child === undefined) {
        return;
    }

    if (child.maxNumber !== undefined && child.maxNumber < value) {
        child.quantity = child.maxNumber;
    } else if (child.stock !== undefined && child.stock < value && !child.noSupplyProductOnControlledStock) {
        child.quantity = child.stock;
    } else {
        child.quantity = value;
    }

    if (child.hasAttributes) {
        const attributesEl = $(child.attributesEl);
        let validationError = false;

        // Attributes polyvalent
        attributesEl.find('[name=attributePolyvalent]').each((_, el) => {
            const value = $(el).val();
            if((value  == '' || value.replace(/\s/g, '').length == 0) && child.quantity > 0 ){
                $(el).addClass('validation-error-js');
                $(el).addClass('validation-error');
                $(el).parents('.attribute-container-js').find('.form__input-info').addClass('validation-error');
                $(el).parents('.attribute-container-js').find('.validation-info-js').removeClass('hidden-js');
                $(el).parents('.attribute-container-js').find('.select-arrow-ui').removeClass('no-error');
                validationError = true;
            } else {
                $(el).removeClass('validation-error-js');
                $(el).removeClass('validation-error');
                $(el).parents('.attribute-container-js').find('.form__input-info').removeClass('validation-error');
                $(el).parents('.attribute-container-js').find('.validation-info-js').addClass('hidden-js');
                $(el).parents('.attribute-container-js').find('.select-arrow-ui').addClass('no-error');
            }
        });

        // Attributes editable
        attributesEl.find('[name=attributeEditable]').each((_, el) => {
            const value = $(el).val();

            // Validate polyvalent editable attributes
            if ((value  == '' || value.replace(/\s/g, '').length == 0) && child.quantity > 0 ){
                $(el).addClass('validation-error-js');
                $(el).addClass('validation-error');
                $(el).parents('.attribute-container-js').find('.form__input-info').addClass('validation-error');
                $(el).parents('.attribute-container-js').find('.validation-info-js').removeClass('hidden-js');
                $(el).parents('.attribute-container-js').find('.select-arrow-ui').removeClass('no-error');
                validationError = true;
            } else {
                $(el).removeClass('validation-error-js');
                $(el).removeClass('validation-error');
                $(el).parents('.attribute-container-js').find('.form__input-info').removeClass('validation-error');
                $(el).parents('.attribute-container-js').find('.validation-info-js').addClass('hidden-js');
                $(el).parents('.attribute-container-js').find('.select-arrow-ui').addClass('no-error');
            }
        });

        // Toggle state of expandable content based on validation flag
        const arrow = $(child.el).find('.expand-data-js');
        if (validationError) {
            if (!arrow.hasClass('cant-toggle-js') && !child.moreAttrOpened) {
                arrow.click();
                child.moreAttrOpened = true;
            }

            arrow.addClass('cant-toggle-js');
            child.cantToggle = true;
        } else {
            arrow.removeClass('cant-toggle-js');
            child.cantToggle = false;
        }
    }

    child.quantityString = toQuantityString(child.quantity);
    input.val(child.quantityString);
    child.buyAll = (child?.maxNumber == child.quantity) || (child?.stock == child.quantity);
}
/**
 * Handles updating a child's saved unit selection and all dependent UI/data.
 *
 * @param {Event} e - The event triggered by a unit change.
 */
function changeSavedUnit(e) {
    const graphicalVariants = $('.graphical-variant-js').length > 0;
    const childEl = graphicalVariants ? $(window.childs[0].graphicalEl) : $(e.currentTarget).parents('.child-js');
    const index = graphicalVariants ? 0 : childEl.data('child-index');
    const child = window.childs[index];
    const unit = $(e.currentTarget).data('value');
    $(e.currentTarget).parents('[data-unit]').attr('data-unit', unit);

    // Legacy: EAN codes handling
    if($('[data-ean]').length > 0 && $(e.currentTarget).parents('.active-js').length > 0){
        var mainEan = $('.main-ean-js').text();
        var ean = $('[data-ean]').data('ean');
        var eanArr = ean.split(',');
        var eansString = mainEan + ',<br>';
        for(var j=0; j<eanArr.length; j++){
            var eanCode = eanArr[j].split('|')[0];
            var id = eanArr[j].split('|')[1];
            if(id == 'null'){
                id = '';
            } else {
                id = Number(id);
            }
            if(unit == id){
               eansString += eanCode + ',<br>';
            }
        }
        ean = eansString.slice(0, -5);
    }

    let ratio;
    let multiplicity;

    const options = $(e.currentTarget).parent().find('li');
    options.each(function () {
        const optionId = $(this).data('value');

        if (optionId != unit) {
            return; // Skip if this option is not the selected unit
        }

        // Multiplicity
        multiplicity = Number($(this).data('multiplicity'));
        if (multiplicity > 0) {
            const info = $(this).parents('.child-js').find('.multiplicity-info-js');
            info.find('.multiplicity-js').html(multiplicity);
            info.find('.name-js').html($(this).html());
        }

        // Ratio
        ratio = $(this).data('ratio');
        if (typeof ratio == 'string' && ratio.indexOf(__decSep) !== -1) {
            ratio = ratio.replace(__decSep, '.');
            ratio = Number(ratio);
        }
    });

    child.unit = unit;
    child.ratio = ratio;
    child.ratio ? child.unitRatioInfo = true : false;

    // Legacy: installment buttons reload
    if ($('.product-presentation-js').index() >= 0 && $('.installmentCalculator').index() >= 0) {
        reloadInstallmentButtons(ratio);
    }

    if(multiplicity > 0){
        if(__decUnits == 'true'){
            var multiplicityString = multiplicity + __decSep + '00';
        }
        childEl.find('[name=quantity]').data('multiplicity', multiplicity);
        child.multiplicity = multiplicity;
        child.multiplicityString = multiplicityString;
    }
    // Legacy : EAN codes handling
    if($('[data-ean]').length > 0 && $(e.currentTarget).parents('.active-js').length > 0){
        window.childs[index].ean = ean;
        $('.ean-js').html(ean);

        var eanCount = ean.split(',').length;
    
        if (eanCount > 1) {
            $('.multiple-ean-js').removeClass('hidden-js');
            $('.one-ean-js').addClass('hidden-js');
        } else {
            $('.multiple-ean-js').addClass('hidden-js');
            $('.one-ean-js').removeClass('hidden-js');   
        }
    }

    // Update unit ratio info if available
    childEl.find('.unit-ratio-info-js').addClass('hidden-js');
    if (unit) {
        childEl.find('.unit-ratio-info-js[data-id=' + unit + ']').removeClass('hidden-js');
    }

    // Update dimensions if available
    const dimensionsEl = childEl.find('.dimensions-js');
    if (dimensionsEl.length > 0) {
        const selectedUnitDimensions = dimensionsEl.attr('data-unit' + unit);
        changeDimensions(selectedUnitDimensions);
    }

    changePrices(childEl, index);
    changeMaxQuantity(child, index);
    loadChildsProps(index);
    var input = graphicalVariants ? childEl.find('[name=quantity]') : $(e.currentTarget).parents('.child-js').find('[name=quantity]');
    app.validation(e, input);
    app.getProperBackground();
}

/**
 * Updates the displayed dimensions (height, length, width) in the UI based on the provided object.
 * Shows or hides the corresponding DOM elements depending on whether each dimension is non-zero.
 *
 * @param {Object} selectedUnitDimensions - The object containing dimension values.
 * @param {number} [selectedUnitDimensions.height] - The height value in centimeters.
 * @param {number} [selectedUnitDimensions.length] - The length value in centimeters.
 * @param {number} [selectedUnitDimensions.width] - The width value in centimeters.
 */
function changeDimensions(selectedUnitDimensions){
	if (!selectedUnitDimensions || selectedUnitDimensions == '||') {
		return;
	}

    selectedUnitDimensions = selectedUnitDimensions.split('|');
    selectedUnitDimensions = {
        height: Number(selectedUnitDimensions[0]) || 0,
        length: Number(selectedUnitDimensions[1]) || 0,
        width: Number(selectedUnitDimensions[2]) || 0
    };

	if (selectedUnitDimensions?.height != 0) {
		$('.height-value-js').text(selectedUnitDimensions.height + ' cm');
		$('.dimensions-height-js').removeClass('hidden-js');
	} else {
		$('.dimensions-height-js').addClass('hidden-js');
	}

	if (selectedUnitDimensions?.length != 0) {
		$('.length-value-js').text(selectedUnitDimensions.length + ' cm');
		$('.dimensions-length-js').removeClass('hidden-js');
	} else {
		$('.dimensions-length-js').addClass('hidden-js');
	}

	if (selectedUnitDimensions?.width != 0) {
		$('.width-value-js').text(selectedUnitDimensions.width + ' cm');
		$('.dimensions-width-js').removeClass('hidden-js');
	} else {
		$('.dimensions-width-js').addClass('hidden-js');
	}
}

/**
 * Updates all price-related DOM elements within a child container according to the current child's
 * pricing data and a scaling ratio. It recalculates and formats brutto/netto current, previous, and
 * lowest (Omnibus) prices, inserting localized decimal separators and currency symbols.
 *
 * @function changePrices
 * @param {HTMLElement | JQuery | string} childEl - Container element (or selector / jQuery ref) whose descendant
 *   elements contain price placeholders to be updated.
 * @param {number} index - Index into the global window.childs array selecting which child's pricing data to render.
 * @returns {void}
 */
function changePrices(childEl, index) {
    const child = window.childs[index];
    
    const graphicalVariants = document.querySelector('.graphical-variant-js') ? true : false;

    $(childEl).find('.brutto-js').each((_, el) => {
        const brutto = child.brutto * child.ratio;
        if (graphicalVariants) {
            $(el).text(brutto.toPrice().replace('.', __decSep) + ' ' + __curr);
        } else {
            $(el).text(brutto.toPrice().replace('.', __decSep));
        }
    });

    $(childEl).find('.netto-js').each((_, el) => {
        const netto = child.netto * child.ratio;
        if (graphicalVariants) {
            $(el).text(netto.toPrice().replace('.', __decSep) + ' ' + __curr);
        } else {
            $(el).text(netto.toPrice().replace('.', __decSep));
        }
    });

    $(childEl).find('.brutto-previous-js').each((_, el) => {
        const bruttoPrevious = child.bruttoPrevious * child.ratio;
        $(el).text(bruttoPrevious.toPrice().replace('.', __decSep) + ' ' + __curr);
    });

    $(childEl).find('.netto-previous-js').each((_, el) => {
        const nettoPrevious = child.nettoPrevious * child.ratio;
        $(el).text(nettoPrevious.toPrice().replace('.', __decSep) + ' ' + __curr);
    });

    $(childEl).find('.brutto-lowest-js').each((_, el) => {
        const bruttoLowest = child.bruttoLowest * child.ratio;
        if (graphicalVariants) {
            $(el).text(bruttoLowest.toPrice().replace('.', __decSep) + ' ' + __curr + ' ' + __translations.brutto + ' - ' + __translations.Price_Omnibus);
        } else {
            $(el).text(__translations.Price_Omnibus + ' ' + bruttoLowest.toPrice().replace('.', __decSep) + ' ' + __curr);
        }
    });

    $(childEl).find('.netto-lowest-js').each((_, el) => {
        const nettoLowest = child.nettoLowest * child.ratio;
        if (graphicalVariants) {
            $(el).text(nettoLowest.toPrice().replace('.', __decSep) + ' ' + __curr + ' ' + __translations.netto + ' - ' + __translations.Price_Omnibus);
        } else {
            $(el).text(__translations.Price_Omnibus + ' ' + nettoLowest.toPrice().replace('.', __decSep) + ' ' + __curr);
        }
    });
}

/**
 * Updates the displayed weight and net weight values for a product child based on its index.
 * 
 * This function calculates and displays the weight and net weight for a specific child product,
 * taking into account unit ratios and product type. It updates the corresponding DOM elements
 * with the calculated values, formatted appropriately.
 *
 * @param {number} index - The index of the child product in the global window.childs array.
 */
function changeWeights(index) {
    const child = window.childs[index];
	const unitRatioExists = document.getElementsByClassName('unit-ratio-js').length > 0;

	if (!unitRatioExists || index < 0 || child === undefined || child.weight === undefined) {
		return;
	}

	let basicUnitRatio = document.getElementsByClassName('unit-ratio-js')[0].dataset.basicUnitRatio;
	if (typeof(basicUnitRatio) === 'string' && basicUnitRatio.includes(',')) {
		basicUnitRatio = Number(basicUnitRatio.replace(',', '.'));
	}

	// Unit information
	let unitInfo = '';

	// Weight calculation
	let weight = child.weight;
	if(child.ratio != undefined){
		weight = (weight * child.ratio / basicUnitRatio).toFixed(4);
	}
	$('.weight-value-js').text(weight.toString().replace('.', ',') + 'kg' + unitInfo);

	// Net weight calculation
	let netweight = child.netweight;
	if(child.ratio != undefined){
		netweight = (netweight * child.ratio / basicUnitRatio).toFixed(4);
	}
    if (netweight !== undefined) {
	    $('.netweight-value-js').text(netweight.toString().replace('.', ',') + 'kg' + unitInfo);
    }
}

/**
 * Changes the maximum quantity for a child product based on its stock and ratio.
 * This function calculates the maximum quantity that can be purchased for a child product,
 * taking into account its stock, ratio, and basic unit.
 * It also updates the child product's quantity and maxString properties,
 * and modifies the DOM elements to reflect these changes.
 * * If the child product has a stock defined, it calculates the maximum quantity based on the stock and ratio.
 * @param {Object} childEl - The jQuery object representing the child product element.
 * @param {number} index - The index of the child
 */
function changeMaxQuantity(childEl, index) {
    const toMaxNumber = (value) => {
        if(__decUnits == 'true'){
            value = Number(value.toString().replace(',','.')).toFixed(4);
            value = value.split('.');
            if(value[1] != undefined) {
                var decimals = value[1];
                var length = decimals.length;
                for(var i=0; i<length; i++){
                    if(decimals.slice(-1) == '0'){
                        decimals = decimals.slice(0, -1);
                        if(i == length - 1){
                            var int = true;
                        }
                    } else {
                        break;
                    }
                }
            }
            value = value[0];
            if(int == undefined){
                value = value + __decSep + decimals;
            }
        } else {
            value = Math.floor(value);
        }
        return value;
    };

	const MAX_INPUT_QUANTITY_VALUE = 99999;
    const child = window.childs[index];

    // If the child product has a stock defined, it calculates the maximum quantity based on the stock and ratio.
    var max = MAX_INPUT_QUANTITY_VALUE;
    if(child?.stock && child?.ratio && child?.basicUnit) {
        max = child.stock / child.ratio * child.basicUnit;
    }

    if(child?.stockNotMax && child?.ratio && child?.basicUnit) {
       max = child.stockNotMax / child.ratio * child.basicUnit;
    }

    // Set max number
    child.maxNumber = toMaxNumber(max);

    if(child.askForPriceChild == false) {
        if(child.quantity >= child.maxNumber ) {
            child.quantity = child.maxNumber;
            child.quantityString = child.maxNumber;
        }
        
        child.buyAll = (child.quantity == child.maxNumber) || (child.stock == child.quantity);
    }

    child.maxString = child.noSupplyProductOnControlledStock ? MAX_INPUT_QUANTITY_VALUE : child.maxNumber;

    // Update UI elements
    $(childEl).find('[data-max]').data('max', child.maxString);
    $(childEl).find('.max-js').text(child.maxString);
}

/**
 * Updates the moreAttrOpened status of a child element in the global window.childs array
 * based on whether the child contains an element with the .expanded-js class.
 *
 * @param {Event} e - The event object triggered by a user interaction.
 */
function saveOpenedStatus(e) {
    const child = $(e.target).closest('.child-js');
    const index = child.data('child-index');

    window.childs[index].moreAttrOpened = false;
    if (child.find('.expanded-js').length > 0) {
        window.childs[index].moreAttrOpened = true;
    }
}

/**
 * Update a child's attribute values and validation UI.
 *
 * - Saves values into attributesEditable or attributesPolyvalent based on "name".
 * - Validates inputs; flags errors and prevents toggle when empty or quantity <= 0.
 * - Toggles the expand arrow state based on validity.
 *
 * @param {Event} e - Event from the attribute control.
 * @param {'attributePolyvalent'|'attributeEditable'} name - Target attribute group.
 */
function saveAttributes(e, name) {
    if (name !== 'attributePolyvalent' && name !== 'attributeEditable') {
        return;
    }

    const graphicalVariants = document.querySelector('.graphical-variant-js') !== null;
    const index = graphicalVariants ? 0 : $(e.currentTarget).closest('[data-child-index]').data('child-index');

    if (index === undefined || index < 0) {
        return;
    }

    const child = window.childs[index];

    child.cantToggle = false;
    const attributes = $(child.attributesEl).find('[name='+name+']');

    attributes.each(function (i) {
        if(name == 'attributePolyvalent') {
            child.attributesPolyvalent[i] = $(this).val();
        } else if (name == 'attributeEditable') {
            child.attributesEditable[i] = $(this).val();
        }

        const value = $(this).val();
        const isEmpty = value === '' || value.replace(/\s/g, '').length === 0;
        const hasValidationError = isEmpty && (!child.graphicalEl && child.quantity > 0);
        if (hasValidationError) {
            child.cantToggle = true;
            $(this).addClass('validation-error-js');
            $(this).addClass('validation-error');
            $(this).parents('.attribute-container-js').find('.form__input-info').addClass('validation-error');
            $(this).parents('.attribute-container-js').find('.validation-info-js').removeClass('hidden-js');
        } else {
            $(this).removeClass('validation-error-js');
            $(this).removeClass('validation-error');
            $(this).parents('.attribute-container-js').find('.form__input-info').removeClass('validation-error');
            $(this).parents('.attribute-container-js').find('.validation-info-js').addClass('hidden-js');
        }
        const arrow = $(child.el).find('.expand-data-js');
        arrow.toggleClass('cant-toggle-js', child.cantToggle);
    });
}

function changeParent(){
    saveChildsProps();
    loadChildsProps();
}

Number.prototype.format = function(n, x, s, c) {
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

Number.prototype.toPrice = function (d) {
    const decimalPlaces = d || __decimalPlacesPrice || 2;
    return this.format(decimalPlaces, 3, ' ', __decSep);
};

(function () {
    if(!location.search.includes('inquiry=true') && window.app.getCookie('lastCartId') == undefined){
        var id = $('.current-cart-js').data('cart-id');
        if (id) {
            window.app.setCookie('lastCartId', id);
        } else {
            window.app.setCookie('lastCartId', -1);
        }
    }
})();

function changeHeaderCart() {
    $('body').on('change','.carts-change-popup-js input', function(){
        $.post(null,{__csrf:__CSRF,__action:'Cart/NameSet',id:$(this).data('id'),name:$(this).val()},function(){location.reload();});
    });

    $('body').on('click', '.change-inquiry-link-js', function(e){
        e.preventDefault();
        
        $('.change-inquiry-js').children().addClass('hidden-js');
        $('.change-inquiry-js .loading-inquiry-in-progress-js').removeClass('hidden-js');
        $('.change-inquiry-js .loader-js').removeClass('hidden-js');
        
        var id = $(this).data('id');
        window.app.setCookie('activeInquiryId', id);
        
        if(window.location.search == '?add-inquiry=true'){
            $.post(null, { __csrf: __CSRF, __action: 'Cart/Change', id: id }, function (res) {
                location.reload();
            });
        } else {
            location.reload();
        }
    });
    $('.inquiry-change-popup-js').click(function(e){
        e.stopPropagation();
        $('.inquiries-change-popup-js').toggle();
    });
}

changeHeaderCart();

if($('.child-js').index() != -1 || $('.choose-variant-js').index() != -1 || $('.lookbook-js').index() != -1){
    window.productsAddedToCart = false;
    changeParent();
    $('body').on('change input blur click', '[name="quantity"]', function(e) {
        e.stopPropagation();
    });
    $('body').on('click', '.child-reload-js:not(.active-js):not(.prevent-instant-reload-js)', function(e) {
		$('.during-ajax-modal-js').removeClass('hidden-js');
        if ($(e.currentTarget).hasClass('change-parent-js')) {
            app.replaceTemplate(e, undefined, changeParent);
        } else {
            app.replaceTemplate(e, undefined, loadChildsProps);
        }
    });
    $('body').on('click', '.child-reload-js input, .child-reload-js select, .child-reload-js button, .units-in-table-js, .child-js .expand-data-js', function(e) {
        e.stopPropagation();
    });
    $('body').on('change', '[name="quantity"]', function(e) {
        if ($(e.currentTarget).hasClass('change-quantity-header-input')) {
            app.changeQuantity(e, undefined, undefined, app.changeQuantityInCartHeader, e);
        } else if(window.childs.length > 0){
            changeSavedQuantity(e);
        }
    });
    $('body').on('click', '.units-in-table-js li', function(e) {
        e.stopPropagation();
        changeSavedUnit(e);
    });
    $('body').on('click', '.change-quantity-in-table-js:not(.disabled-js)', function(e) {
        e.stopPropagation();
        app.changeQuantity(e, undefined, undefined, changeSavedQuantity, e);
    });
    $('body').on('keydown', '.change-quantity-in-table-js:not(.disabled-js)', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                app.changeQuantity(e, undefined, undefined, changeSavedQuantity, e);
            }    
    });
    $('body').on('click', '.not-last-lvl-js:not(.prevent-instant-reload-js)', function(e) {
        e.preventDefault();
        if($(e.currentTarget).hasClass('not-last-lvl-js')){
			$(".during-ajax-modal-js").removeClass("hidden-js");
            app.replaceTemplate(e, undefined, changeParent);
        }
    });
    $('body').on('click', '[data-many-attributes-id]', function(e) {
        app.changeInputValue(e, 'many-attributes-id', '.attributes-js', 'attributeId', changeParent);
    });
    $('body').on('change click', '.attr-graphical-variants-js .graphical-variant-js input[type="radio"][name="attributeId"]', function(e) {
        changeParent();
    });
    $('body').on('click', '.child-js .expand-data-js:not(.cant-toggle-js)', function(e) {
        e.stopPropagation();
        saveOpenedStatus(e);
    });
    $('body').on('click', '[data-name=attributePolyvalent]', function(e) {
        e.stopPropagation();
        saveAttributes(e, 'attributePolyvalent');
    });
    $('body').on('input', '[name=attributeEditable]', function(e) {
        e.stopPropagation();
        saveAttributes(e, 'attributeEditable');
    });
} else {
    $('body').on('change', '.change-quantity-header-input', function(e) {
        app.changeQuantity(e, undefined, undefined, app.changeQuantityInCartHeader, e);
    });
}

$('body').on('change', 'select.not-last-lvl-js', function(e) {
    app.replaceTemplate(e);
});

$('body').on('change', 'select.attribute-polyvalent-change-js', function(e) {
    const parentContainer = $(e.currentTarget).parents('.select-attribute-container-js');
    parentContainer.find('input[name=attributeId]').val($(e.currentTarget).val());
});

if (document.getElementsByClassName('attributes-list-js').length > 0){
    app.getProperBackground();
}

async function chooseVariantOnProductsList(e) {
    const currentTarget = e.currentTarget;
    let url = currentTarget.dataset.url;
    let isSource = false;

    if (!url && currentTarget.selectedOptions) {
        url = currentTarget.selectedOptions[0].dataset.url;
    }
    if (__recommendedAIInCart == 'yes' && $('.order-template-js').index() >= 0) {
        url = url + '?ai-cart-recommendation=true';
        isSource = true;
    }
    let include = '';
    if ($('input[type=checkbox][name="showMore"]:checked').length > 0) {
        include = '"checked"';
    }

    let data = await new Promise(resolve => $.get(url, {
            __template: 'partials/products/add-variants-to-cart.html',
            __include: include
        }, resolve));
        if (data && data.template) {
            template = data.template;
        }
    if (currentTarget.dataset.cart && currentTarget.dataset.cart == 'true') {
        const data = await new Promise(resolve => $.get(url, {
            __template: 'partials/products/add-variants-to-cart.html',
            __include: '"in-cart"'.concat(include ? ',' + include : '')
        }, resolve));
        if (data && data.template) {
            template = data.template;
        }
    }
    if (currentTarget.dataset.lookbook && currentTarget.dataset.lookbook == 'true') {
        const data = await new Promise(resolve => $.get(url, {
            __template: 'partials/products/add-variants-to-cart.html',
            __include: '"in-lookbook"'.concat(include ? ',' + include : '')
        }, resolve));
        if (data && data.template) {
            template = data.template;
        }
    }
    const dialogSelector = '.add-variants-to-cart-from-prod-list-popup-background-js';
    let dialog = document.querySelector(dialogSelector);

    if (dialog) {
        const fragment = document.createRange().createContextualFragment(template);
        
        const newDialogContent = fragment.querySelector(dialogSelector);
        
        if (newDialogContent) {
            dialog.innerHTML = '';
            
            Array.from(newDialogContent.childNodes).forEach(node => {
                dialog.appendChild(node.cloneNode(true));
            });
        }
    } else {
        document.getElementById('main').insertAdjacentHTML('afterend', template);
        dialog = document.querySelector(dialogSelector);
        dialog.showModal();
    }

    if (isSource) {
        $('#sourceToAdd-js').val(2);
    }

    changeParent();
    app.selects($('.add-variants-to-cart-from-prod-list-popup-background-js'));
    app.formLabelAnimationOnLoadPage();
};

$('body').on('click', '.choose-variant-js, .change-variant-on-products-list-js:not(select):not(.prevent-instant-reload-js)', function(e) {
    e.preventDefault();
    e.stopPropagation();
    chooseVariantOnProductsList(e);
});

$('body').on('change', '.change-variant-on-products-list-js:not(.prevent-instant-reload-js)', function(e) {
    e.preventDefault();
    e.stopPropagation();
    chooseVariantOnProductsList(e);
});

$('body').on('click', '.open-next-element-js', function(e) {
    $(e.currentTarget).next().removeClass('hidden-js');
});
`